module.exports = __webpack_public_path__ + "static/img/boli.65a8f668.svg";